const state = {
  user: {
    editable: false,
    slug: "",
    first_name: "",
    last_name: "",
    username: "",
    is_active: true,
    mobile: "",
    gender: "",
    photo_url: "",
    city: 0,
    city_name: "",
    province: 0,
    province_name: "",
    groups: [0],
    step: 0,
    rate: null,
    seventh_year: 0,
    old_hadian: "",
    age: 0,
    email: "",
    trusted: true,
    gender_limit: true,
    profile: {
      user: 0,
      nationality: "",
      birth_date: "",
      postal_code: "",
      address: "",
      tell: "",
      parent_mobile: "",
      father_name: "",
      father_job: "",
      mother_job: "",
      married: false,
      telegram_id: "",
      soroush_id: "",
      ita_id: "",
      bale_id: "",
      igap_id: "",
      instagram_id: "",
      gilder: "",
      background: "",
      educ: "",
      father_educ: "",
      mother_educ: "",
      school_major: "",
      personnel_code: null,
      univ_status: null,
      military_status: null,
      contact_status: null,
      job_type: "",
      job_title: "",
      job_org: 0,
      job_org_name: "",
      active_role_count: 0,
      rate: null,
      skills: [],
    },
    actor_set: [
      {
        year: 0,
        role: 0,
        role_title: "",
        unit_name: "",
        unit_url: "",
        is_active: true,
        is_member_of_cabinet: false,
      },
    ],
    teammember_set: [{ year: 0, team_title: "", team_slug: "" }],
    experiences: [
      {
        id: 0,
        ngo: 0,
        ngo_title: "",
        post: "",
        years: 0,
        domain: "",
        description: "",
        registrar: "",
      },
    ],
    graduates: [
      {
        id: 0,
        entrance_year: 0,
        univ: 0,
        univ_name: "",
        major: 0,
        major_title: "",
        is_student: false,
        registrar: "",
      },
    ],
  },
  skill_list: [],
};

const getters = {
  User: (state) => state.user,
  SkillList: (state) => state.skill_list,
};

const mutations = {
  setUser(state, payload) {
    state.user = payload;
    console.log(payload);
  },
  setUserUpdate(state, payload) {
    state.user.city = payload.city;
    state.user.city_name = payload.city_name;
    state.user.first_name = payload.first_name;
    state.user.last_name = payload.last_name;
    state.user.mobile = payload.mobile;
    state.user.nationality = payload.nationality;
    state.user.birth_date = payload.birth_date;
    state.user.postal_code = payload.postal_code;
    state.user.address = payload.address;
    state.user.tell = payload.tell;
    state.user.parent_mobile = payload.parent_mobile;
    state.user.father_name = payload.father_name;
    state.user.father_job = payload.father_job;
    state.user.mother_job = payload.mother_job;
    state.user.married = payload.married;
    state.user.telegram_id = payload.telegram_id;
    state.user.soroush_id = payload.soroush_id;
    state.user.ita_id = payload.ita_id;
    state.user.bale_id = payload.bale_id;
    state.user.igap_id = payload.igap_id;
    state.user.instagram_id = payload.instagram_id;
    state.user.email = payload.email;
    state.user.gilder = payload.gilder;
    state.user.background = payload.background;
    state.user.educ = payload.educ;
    state.user.father_educ = payload.father_educ;
    state.user.mother_educ = payload.mother_educ;
    state.user.school_major = payload.school_major;
    state.user.seventh_year = payload.seventh_year;
    state.user.step = payload.step;
    state.user.age = payload.age;
    state.user.personnel_code = payload.personnel_code;
  },
  setUserActivity(state, payload) {
    state.user.is_active = payload;
  },
  setUserTrust(state, payload) {
    state.user.trusted = payload;
  },
  setUserGroupToMentor(state) {
    state.user.groups = [2];
  },
  setUserPhoto(state, payload) {
    state.user.photo_url = payload;
  },
  setSkillList(state, payload) {
    state.skill_list = payload;
  },
};

const actions = {
  setUserTrust({ commit }, payload) {
    commit("setUserTrust", payload);
    try {
      commit("setTrustInStudentList", {
        slug: state.user.slug,
        trusted: payload,
      });
    } catch (e) {}
  },
  setUserUpdate({ commit }, payload) {
    commit("setUserUpdate", payload);
    try {
      commit("setUserUpdateInStudentList", {
        slug: state.user.slug,
        full_name: payload.first_name + " " + payload.last_name,
        step: payload.step,
      });
    } catch (e) {}
    try {
      commit("setUserUpdateInMentorList", {
        slug: state.user.slug,
        full_name: payload.first_name + " " + payload.last_name,
      });
    } catch (e) {}
  },
  setUserPhoto({ commit }, payload) {
    commit("setUserPhoto", payload);
    try {
      commit("setUserPhotoInStudentList", {
        slug: state.user.slug,
        photo_url: payload,
      });
    } catch (e) {}
    try {
      commit("setUserPhotoInMentorList", {
        slug: state.user.slug,
        photo_url: payload,
      });
    } catch (e) {}
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
